/* 4DELTAS V12 — display-only 3 decimal digits, not currency processing. */
(() => {
  if (window.__fgV12MoneyDisplay) return;
  window.__fgV12MoneyDisplay = true;
  const targets = [
    '.price', '.price-item__group', '.compare-at-price', '.unit-price',
    '.fg-v5-card-cta__amount', '.fgc-price', '.fg-cj-price', '.fg-cj-compare-price',
    '.fg-cj-total-price', '.fg-cj-unit-price', '.fg-cj-b2b-price-detail',
    '.fg-cj-b2b-summary', '.fg-cj-b2b-pricing', '.fg-cj-volume',
    '.cart-items__price', '.cart-items__unit-price-wrapper', '.cart-totals__original-value',
    '.cart-totals__total-value', '.cart-discounts__value',
    '.product-card__price', '.product-price', '[data-fg-price]',
    '[data-fg-total-price]', '[data-fg-b2b-summary-unit]', '.volume-pricing'
  ].join(',');
  // Only extend actual two-decimal money numbers; preexisting three-decimal
  // prices (e.g. from an external pricing app) are left unchanged.
  const three = s => s.replace(/(\d[\d,]*)([.,])(\d{2})(?!\d)/g, '$1$2$30');
  function fix(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches?.(targets)) fixText(node);
    node.querySelectorAll?.(targets).forEach(fixText);
  }
  function fixText(el) {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) {
      const n = walker.currentNode;
      const parent = n.parentElement;
      if (parent?.closest('script,style,template,textarea,input,[contenteditable="true"]')) continue;
      if (!/\d[\d,]*[.,]\d{2}(?!\d)/.test(n.nodeValue)) continue;
      const val = three(n.nodeValue);
      if (val !== n.nodeValue) textNodes.push([n,val]);
    }
    textNodes.forEach(([node,text]) => node.nodeValue = text);
  }
  const start = () => {
    fix(document.body);
    const observer = new MutationObserver(mutations => {
      for (const m of mutations) {
        if (m.type === 'characterData') {
          const parent = m.target.parentElement;
          const match = parent?.closest(targets);
          if (match) fixText(match);
        } else {
          m.addedNodes.forEach(n => {
            if (n.nodeType === 1) fix(n);
            else if (n.nodeType === 3) {
              const match = n.parentElement?.closest(targets);
              if (match) fixText(match);
            }
          });
        }
      }
    });
    observer.observe(document.body, {subtree:true, childList:true, characterData:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
